import React from 'react';

function Footer() {
  return (
    <footer>
      <div>
        <p>Contact me: dramawizz@gmail.com</p>
      </div>
    </footer>
  );
}

export default Footer;